import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { QuickAdd } from '@ui/general';
import { useCreateInitiativeTask } from '@hooks';

import React, { useCallback, useEffect, useRef, useState } from 'react';

export interface CreateTaskProps {
	initiativeId: number;
	onFinish: (taskId: number, taskName: string) => void;
}

export const CreateTask: React.FC<CreateTaskProps> = ({ initiativeId, onFinish }) => {
	const { isProcessing, isSuccessful, request, reset, result } = useCreateInitiativeTask(initiativeId);
	const [ taskName, setTaskName ] = useState<string>('');

	const onFinishRef = useRef(onFinish);
	onFinishRef.current = onFinish;

	const handleOnSubmit = useCallback((name: string) => {
		setTaskName(name);
		request({ name });
	}, [ request ]);

	useEffect(() => {
		if (isSuccessful && result) {
			onFinishRef.current(result.initiativeTaskId, taskName);
			reset();
		}
	}, [ isSuccessful, reset, result, taskName ]);

	return <QuickAdd
		onSubmit={ handleOnSubmit }
		processing={ isProcessing }
		typeLabel={ COPY_SPECIFIC.TASK } />;
};
